import { stringify } from 'qs';
import request from '@/utils/request';
import { loginOrg, loginUser, loginCompany } from '@/utils/LoginContext';

export async function queryresult(params) {
  return request(`/iwms-wms/wms/onlinereview/queryresult`, {
    method: 'POST',
    body: params,
  });
}

export async function carrierhandover(payload) {
  return request(`/iwms-wms/wms/carrierhandover`, {
    method: 'POST',
    body: payload
  })
}

export async function saveAndAudit(payload) {
  return request(`/iwms-wms/wms/carrierhandover/saveAndAudit`, {
    method: 'POST',
    body: payload
  })
}

export async function carrierhandoverRemove(payload) {
  return request(`/iwms-wms/wms/carrierhandover/${payload.uuid}?version=${payload.version}`, {
    method: 'DELETE',
  })
}

export async function page(payload) {
  return request(`/iwms-wms/wms/carrierhandover/page`, {
    method: 'POST',
    body: payload
  })
}

export async function audit(payload) {
  return request(`/iwms-wms/wms/carrierhandover/${payload.uuid}/audit?version=${payload.version}`, {
    method: 'POST',
  })
}

export async function get(payload) {
  return request(`/iwms-wms/wms/carrierhandover/${payload.billNumber}/get?dcUuid=${payload.dcUuid}`, {
    method: 'GET',
  })
}

export async function getByUuid(payload) {
  return request(`/iwms-wms/wms/carrierhandover/${payload.uuid}`, {
    method: 'GET',
  })
}

export async function queryReviewresult(payload) {
  return request(`/iwms-wms/wms/onlinereview/queryresult`, {
    method: 'POST',
    body: payload
  })
}
